import { api } from "./api";

export async function getGlobalConfig(id: string) {
    const { data } = await api.get(`database/global__c?q_id:"${id}"`);
    return data;
}